module.exports = __webpack_public_path__ + "static/garantie-25-37245b71e55ea8eb93bdcfd991296a7d.svg";